import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { importProjectSettingsFromFile } from '../../utils/ProjectSettingsUtils';

interface ProjectSettingsImportProps {
  onImportSuccess: (settings: Record<string, string | number>) => void;
  onImportError?: (error: string) => void;
  disabled?: boolean;
  tooltip?: string;
}

const ProjectSettingsImport: React.FC<ProjectSettingsImportProps> = ({
  onImportSuccess,
  onImportError,
  disabled = false,
  tooltip = "Import Settings"
}) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    importProjectSettingsFromFile(file)
      .then((settings) => {
        if (settings) {
          onImportSuccess(settings);
        }
      })
      .catch((error) => {
        console.error('Error parsing CSV:', error);
        const errorMessage = 'Error parsing the imported file. Please make sure it is a valid CSV file.';
        if (onImportError) {
          onImportError(errorMessage);
        } else {
          alert(errorMessage);
        }
      });
    
    // Reset the input so the same file can be selected again
    event.target.value = '';
  };

  return (
    <>
      <input
        type="file"
        accept=".csv"
        style={{ display: 'none' }}
        id="project-settings-import"
        onChange={handleFileChange}
        disabled={disabled}
      />
      <label htmlFor="project-settings-import">
        <Tooltip title={tooltip}>
          <span>
            <IconButton component="span" disabled={disabled}>
              <FileUploadIcon />
            </IconButton>
          </span>
        </Tooltip>
      </label>
    </>
  );
};

export default ProjectSettingsImport;
